import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../services/api";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import "./LoginPage.css";
import Navbar from "../../components/Navbar/Navbar";

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login, token } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  React.useEffect(() => {
    if (token) {
      navigate("/home", { replace: true });
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await api.post('/login', { username, password });

      if (response.data.token) {
        login(response.data.user || {}, response.data.token);
        navigate("/home");
      }
    } catch (err) {
      setError(err.response?.data?.message || t("login_error", "Ocorreu um erro. Tente novamente."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Navbar />
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h2>{t("login_title", "Login")}</h2>
            <p>{t("login_subtitle", "Bem-vindo de volta")}</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && <div className="error-alert">{error}</div>}

            <div className="input-group">
              <label>{t("username", "Usuário")}</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder={t("username_placeholder", "Nome de usuário")}
                required
              />
            </div>

            <div className="input-group">
              <label>{t("password", "Senha")}</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  className="show-password-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Esconder senha" : "Mostrar senha"}
                >
                  {showPassword ? (
                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                  ) : (
                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  )}
                </button>
              </div>
              <div className="forgot-password-link">
                <Link to="/forgot-password">{t('forgot_password', 'Esqueceu a senha?')}</Link>
              </div>
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? t("loading", "Carregando...") : t("login_button", "Entrar")}
            </button>
          </form>

          <div className="login-footer">
            <Link to="/register" className="toggle-btn">
              {t("dont_have_account", "Não tem uma conta? Cadastre-se")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
